<template>
  
  <div class="ui grid animated fadeIn">
    <div class="ui sixteen wide column">
      <file-upload
        ref="fileUpload"
        fileType="image"
        :uploadPath="`/certs/${this.cert.id}/images`"
        :loader="loadImages"
        :readOnly="!this.$isSimavet()"
        sendButtonLabel="Enviar imagem"
        dragTipLabel="Você também pode arrastar as imagens aqui"
        sendingLabel="Enviando imagens..."
        noUploadedFilesLabel="Nenhuma imagem enviada"
        @onRemove="onRemoveImage"
      /> 
    </div>
  </div>    

</template>

<script>

  import CertService from "@/services/cert-service"
  import FileUpload from "@/components/file-upload"

  export default {
    
    name: "CertImagesTab",

    data() {
      return {
        service: new CertService(),
      }
    },

    props: ["cert"],

    components: {
      FileUpload,
    },

    mounted() {
      this.$refs.fileUpload.loadFiles()
    },

    methods: {

      async loadImages() {
        return this.service.getImages(this.cert.id)        
      }, 

      async onRemoveImage(image) {

        try {

          await this.service.removeImage(this.cert.id, image) 
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },
    },
  }

</script>